export const paymentTypeMap = {
  visa: 'Visa',
  mc: 'Mastercard',
};
